import { render } from "./Zakazka.vue?vue&type=template&id=820dd6c4"
import script from "./Zakazka.vue?vue&type=script&lang=js"
export * from "./Zakazka.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\Arion\\SATRA\\SATRA_Inzenyring\\inzenyring\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__